import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import type {
  ISaveTranslationsPayload,
  ISaveTranslationsResponse,
} from '../types';
import {
  SAVE_TRANSLATION_URL,
  TRANSLATE_MANAGER_PERMISSIONS,
  TRANSLATE_MANAGER_SAVE_TRANSLATION_MUTATION_KEY,
} from '../constants';

export default function useSaveTranslationMutation(): IContextMutationResult<ISaveTranslationsResponse, Error, ISaveTranslationsPayload> {
  const { fetchPost } = useRestClient();

  return useContextMutation<ISaveTranslationsResponse, Error, ISaveTranslationsPayload>({
    mutationKey: [TRANSLATE_MANAGER_SAVE_TRANSLATION_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<ISaveTranslationsResponse>(SAVE_TRANSLATION_URL, payload, {
      permission: TRANSLATE_MANAGER_PERMISSIONS.TRANSLATEMANAGER_EDIT,
    }),
  });
}
